import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = ['Más de 1000 actividades', 'Técnicas artísticas paso a paso', 'Recursos visuales', 'Material imprimible', 'Secuencias didácticas', 'Proyectos completos', 'Evaluaciones', 'Planificaciones listas', 'Actividades para todo el año', 'Organización por temas'];
export function TomoIncludes() {
  return <section className="py-20 lg:py-24 bg-ink-50" data-id="element-208">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-210">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-ink-700 font-bold text-xs uppercase tracking-wider mb-5 border border-ink-100 shadow-soft" data-id="element-211">
            Todo incluido
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-212">
            Todo lo que recibís{' '}
            <span className="text-brand-500" data-id="element-213">en un solo lugar</span>
          </h2>
          <p className="text-lg text-ink-600" data-id="element-214">
            Un sistema completo. Sin archivos sueltos, sin buscar en mil
            carpetas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-card border border-ink-100" data-id="element-215">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4" data-id="element-216">
            {features.map((f, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="flex items-center gap-3 py-3 border-b border-ink-100 last:border-0 sm:[&:nth-last-child(2)]:border-0" data-id="element-217">
                <div className="w-8 h-8 rounded-full bg-brand-500 text-white flex items-center justify-center shrink-0 shadow-cta" data-id="element-218">
                  <Check className="w-4 h-4" strokeWidth={3} data-id="element-219" />
                </div>
                <span className="font-semibold text-ink-900 text-base lg:text-lg" data-id="element-220">
                  {f}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}